var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoteFromCustomer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 17 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M23.5 7a.5.5 0 0 1 .5.5V12a.5.5 0 0 1-.5.5h-1L19 15l1-2.5h-3.5a.5.5 0 0 1-.5-.5V7.5a.5.5 0 0 1 .5-.5zm-7.75 10.019c3.018.486 5.25 2.193 5.25 4.23v.876a.875.875 0 0 1-.875.875H7.875A.874.874 0 0 1 7 22.125v-.875c0-2.038 2.232-3.745 5.25-4.231v-.63a3.48 3.48 0 0 1-1.75-3.014V12.5A3.5 3.5 0 0 1 14 9c.35 0 .681.068 1 .163V12c0 .828.673 1.5 1.5 1.5h.991a3.49 3.49 0 0 1-1.741 2.89z"
})));
export default SvgNoteFromCustomer;